import { GetBizsolEmailQuery } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const getBizsolEmailHandler = graphql.query<GetBizsolEmailQuery>(
  "getBizsolEmail",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        bizSolUserInfo: {
          email: "retrieve@mfw.com",
        },
      },
    });
  }
);
